import {Customization} from '@eduvision/toolkit';
import {default as CustomLoggedInView} from '../views/LoggedInView';

export const LoggedInView: Customization['LoggedInView'] = {
  component: CustomLoggedInView
};